'use strict';
'use client';
import { j as h } from "../../../external/react/jsx-runtime.js";
import { useRef as V, useState as s, useCallback as x, useLayoutEffect as w } from "react";
import N from "../Input.js";
import o from "../../../external/card-validator/dist/index.js";
import { faCreditCard as R } from "../../../external/@fortawesome/pro-regular-svg-icons/index.js";
import { faCcMastercard as j, faCcVisa as y, faCcAmex as A } from "../../../external/@fortawesome/free-brands-svg-icons/index.js";
const L = ({ onChange: l }) => {
  const u = V(null), [c, m] = s(""), [f, i] = s(""), [n, p] = s({
    start: 0,
    end: 0,
    direction: "forward"
  }), d = (r) => r.replaceAll(" ", ""), C = (r) => {
    const e = o.number(r);
    let t = "";
    if (!e.card || !e.card.gaps)
      return r;
    for (let a = 0; a < r.length; a++)
      e.card.gaps.includes(a) && (t += " "), t += r[a];
    return t;
  }, b = x(
    (r, e) => {
      if (r === null) return;
      const t = r += e.charAt(r - 1) === " " ? 1 : 0;
      p({
        start: t,
        end: t,
        direction: "forward"
      });
    },
    []
  ), g = (r) => {
    const e = d(r.target.value), t = o.number(e), a = C(e);
    m(a), b(r.target.selectionEnd, a), l({
      value: e,
      isValid: t.isValid
    }), i(t.isPotentiallyValid ? "" : "Invalid card number");
  }, v = (r) => {
    if (r.target.value === "") return;
    o.number(r.target.value).isValid || i("Invalid card number");
  };
  w(() => {
    var r;
    (r = u.current) == null || r.setSelectionRange(n.start, n.end);
  }, [n.start, n.end, n.direction]);
  const I = () => {
    var t;
    const r = d(c);
    switch ((t = o.number(r).card) == null ? void 0 : t.type) {
      case "american-express":
        return A;
      case "visa":
        return y;
      case "mastercard":
        return j;
      default:
        return R;
    }
  };
  return /* @__PURE__ */ h.jsx(
    N,
    {
      ref: u,
      name: "cardNumber",
      label: "Card number",
      placeholder: "Enter card number",
      autoComplete: "cc-number",
      inputMode: "numeric",
      value: c,
      onChange: g,
      onBlur: v,
      error: f,
      rightIcon: I()
    }
  );
};
export {
  L as default
};
